import { Routes } from "@/app/routes.ts";
import NewConversationIcon from "@/assets/new-conversation.svg";
import { useMobileMenuContext } from "@/components/layouts/MobileMenuProvider.tsx";
import { type ColorValue, Div, LinkButton, SvgImage, Text, useColorSchemeValue } from "@hopper-ui/components";
import { useSharedTranslation, useTracking } from "@workleap-ai/shared";
import { useCallback } from "react";

import { MixpanelEvent } from "@workleap-ai/shared/types";
import "./SidebarMenu.css";
import "./SidebarMenu.dark.css";

export const SidebarMenu = () => {
    const { tShared } = useSharedTranslation();
    const { toggleMobileMenu } = useMobileMenuContext();
    const { trackEvent } = useTracking();

    const onNewChatPress = useCallback(() => {
        trackEvent(MixpanelEvent.NewChatClicked, {});
        toggleMobileMenu();
    }, [toggleMobileMenu, trackEvent]);

    const color = useColorSchemeValue(
        "core_orchid-bloom-700",
        "core_orchid-bloom-75"
    ) as ColorValue;

    const background = useColorSchemeValue(
        "var(--wai-new-conversation-gradient)",
        "var(--wai-new-conversation-gradient)"
    );

    const borderWidth = useColorSchemeValue(
        "0.0625rem",
        "0"
    );

    return (
        <Div
            paddingX="inset-sm"
        >
            <LinkButton
                onPress={onNewChatPress}
                href={Routes.Home()}
                variant="secondary"
                paddingX="inset-sm"
                paddingY="inset-md"
                justifyContent="center"
                width="100%"
                color={color}
                border="core_orchid-bloom-400"
                className="wai-new-conversation-button"
                transition="transform 0.2s ease"
                style={{ background, borderWidth }}
            >
                <SvgImage
                    slot="icon"
                    src={NewConversationIcon}
                    aria-label={tShared("newChat")}
                    height="core_160"
                    width="core_160"
                    fill="inherit"
                />
                <Text marginLeft="inline-xs">{tShared("newChat")}</Text>
            </LinkButton>
        </Div>
    );
};
